export const timeElapsed = (date) => {
  const now = new Date();
  const past = new Date(date);
  const diffInSeconds = Math.floor((now - past) / 1000);

  if (diffInSeconds < 59) {
    const seconde = Math.abs(diffInSeconds + 1);
    return `${seconde > 5 ? seconde + "s" : "À l'instant"}`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 59) {
    return `${Math.abs(diffInMinutes + 1)} min`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 23) {
    return `${Math.abs(diffInHours + 1)} h`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return `${Math.abs(diffInDays) === 0 ? 1 : Math.abs(diffInDays)} j`;
  }

  const diffInWeeks = Math.floor(diffInDays / 7);
  if (diffInWeeks < 4) {
    return `${Math.abs(diffInWeeks)} sem`;
  }

  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 3) {
    return `${Math.abs(diffInMonths)} mois`;
  }

  const diffInQuarters = Math.floor(diffInMonths / 3);
  if (diffInQuarters < 4) {
    return `${Math.abs(diffInQuarters)} trimestre${
      Math.abs(diffInQuarters) > 1 ? "s" : ""
    }`;
  }

  const diffInYears = Math.floor(diffInMonths / 12);
  return `${Math.abs(diffInYears)} an${Math.abs(diffInYears) > 1 ? "s" : ""}`;
};

export const formatUnixToDate = (unix) => {
  const date = new Date(unix);
  return date.toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatMessageDate = (unixTimestamp) => {
  const now = new Date();
  const messageDate = new Date(unixTimestamp);

  // Vérifier si la date du message est aujourd'hui
  if (messageDate.toDateString() === now.toDateString()) {
    return "Aujourd'hui";
  }

  // Vérifier si la date du message est hier
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (messageDate.toDateString() === yesterday.toDateString()) {
    return "Hier";
  }

  // Sinon, retourner la date complète sous le format "jour mois année"
  return formatUnixToDate(unixTimestamp);
};
